import { createContext, useState } from "react";
import PropTypes from "prop-types";

const ChatStateContext = createContext();

export const ChatStateProvider = ({ children }) => {
  const [isChatActive, setIsChatActive] = useState(false);

  return (
    <ChatStateContext.Provider value={{ isChatActive, setIsChatActive }}>
      {children}
    </ChatStateContext.Provider>
  );
};

ChatStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChatStateContext;
